import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';

export interface CardItemBoneProps {
    /** Largeur du contenu */
    contentWidth?: string;
    /** Hauteur du contenu */
    contentHeight?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const CardItemBone: React.FunctionComponent<CardItemBoneProps> = function ({
    contentWidth = '100%',
    contentHeight = '78px',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                ...sx,
            }}
        >
            <BoxBone sx={{ width: contentWidth, height: contentHeight }} />
        </Box>
    );
};
